export const StudyListingPageStyle = (theme) => ({
  studyListingStatus: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    width: "100%",
  },

  studyListingStatusSelect: {
    width: 180,
  },

  leftPanel: {},

  mainPanel: {},

  sideBarSection: {
    mb: 5,
  },

  boxBorder: {
    p: 2,
    mt: 1,
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "8px 16px",
  },
});
